import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FieldConfig } from 'src/app/core/interfaces/field-config';
import { Option } from 'src/app/core/interfaces/options-dynamicform';
import { BroadcastService } from 'src/app/shared/services/broadcast.service';
import { DynamicFormServiceService } from 'src/app/shared/services/dynamic-form-service.service';

@Component({
    selector: 'app-select-search-box',
    templateUrl: './select-search-box.component.html',
    standalone: false
})
export class SelectSearchBoxComponent implements OnInit {

  field: FieldConfig;
  group: UntypedFormGroup;
  noData: boolean;
  massDropdown = new Observable<Option[]>();
  sortedOptions: Option[];
  noRecord = 'noRecord';
  isRequired: boolean;

  constructor(private broadCastService: BroadcastService, private dynamicService: DynamicFormServiceService) { }

  ngOnInit() {
    this.massDropdown = of(this.sortedOptions = this.sortedSequence());
    this.group.get(this.field.labelCode).valueChanges.subscribe(x => this.noData = false);
    this.massDropdown = this.group.get(this.field.labelCode).valueChanges
      .pipe(
        startWith(''),
        map(value => value),
        map(name => name ? this._filterCodeValues(name) : this.sortedOptions.slice())
      );
    this.isRequired = this.dynamicService.checkHasRequired(this.field);
  }

  selectionOptionChanged(event: MatAutocompleteSelectedEvent) {
    if (event.option && event.option.id !== this.noRecord) {
      this.group.get(this.field.labelCode).setValue(event.option.viewValue);
    }
  }

  _filterCodeValues(value: string) {
    const word = value.toLowerCase().trim();
    let acc: Option[] = [];
    const val = this.sortedOptions.filter(o =>
      Object.keys(o).some(k => (o.value).toLowerCase().includes(word)));
    acc = acc.concat(val).filter((v, i, a) => a.indexOf(v) === i);
    this.noData = acc.length <= 0;
    return acc;
  }

  private sortedSequence() {
    return ((this.field.labelCode === 'SONOID' ||
      this.field.labelCode === 'SSUPER') ?
      this.field.options.sort((a, b) => {
        const left = a.value.toUpperCase();
        const right = b.value.toUpperCase();
        if (left < right) {
          return -1;
        }
        if (left > right) {
          return 1;
        }
        return 0;
      }) : this.field.options.sort((a, b) => a.sequence - b.sequence));
  }
}
